/*
 users api
*/

import axios from "../axios/axios";

export function getUsersApi() {
  return axios.post('/users/get', {});
}

export function getExtUsersApi(params) {
  return axios.post('/users/getExtUsers', params);
}

export function getLastLoginApi(params) {
  return axios.get('/users/getLastLogin', params);
}

export function getLoggedInStatusApi(params) {
  return axios.get('/users/getLoggedInStatus', params);
}

export function getLoginsByPeriodApi(params) {
  return axios.get(`/users/getLoginsByPeriod?period=${params}`);
}

export function getRefItemExtUserRelsApi(params) {
  return axios.post('/users/getRefItemExtUserRels', params);
}

export function changeUsersApi(params) {
  return axios.post('/users/change', params);
}

export function addUsersApi(params) {
  return axios.post('/users/add', params);
}

export function deleteUsersApi(params) {
  return axios.post('/users/delete', params);
}

export function getActivitiesApi(params) {
  return axios.post('/stats/getactivities', params);
}
